export default __webpack_public_path__ + "static/media/bampowcomiccover.a3278671.png";